/**
 * The page's scroll lock is shared by everything that covers the page and holds it still: the first to open locks it and
 * the last to close puts back what was there, whatever order stacked or handed-over surfaces (a lightbox, a modal
 * drawer) open and close in. Used by components/Lightbox.tsx and screens/useDrawers.tsx.
 */
let scrollLocks = 0;
let scrollSaved = "";
export function lockScroll(): () => void {
  if (scrollLocks++ === 0) {
    scrollSaved = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--scrollLocks === 0) document.body.style.overflow = scrollSaved;
  };
}
